export default function formatTime(timeStr) {
  // timeStr example: "00:00:15.310"
  const [hh, mm, rest] = timeStr.split(':')
  const ss = rest.split('.')[0] // remove milliseconds

  const hours = parseInt(hh, 10)
  const minutes = parseInt(mm, 10)
  const seconds = parseInt(ss, 10)

  // If hours > 0 → include hours, otherwise just MM:SS
  if (hours > 0)
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`

  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

export function toSeconds(formattedTime) {
  // formattedTime can be "HH:MM:SS" or "MM:SS"
  const parts = formattedTime.split(':').map(Number)

  let hours = 0
  let minutes = 0
  let seconds = 0

  if (parts.length === 3) [hours, minutes, seconds] = parts
  else if (parts.length === 2) [minutes, seconds] = parts

  return hours * 3600 + minutes * 60 + seconds
}
